<template>
  <div class="km__modules__text--typeface">
    <ul v-if="currentSelOb !== null" class="km__list--modules">
      <li class="km__list__element--modules"
          v-for="(font) in fonts"
          :key="font.FontID"
          :class="{active:font.Font === currentSelOb.font}"
      >
        <span class="km__typeface">
          <img :alt="'fontimage' + font.Font" :src="getSVGName(font.url)"
               @click="fontSelected(currentSelOb.id, font.Font)">
      </span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>

import {computed, ComputedRef} from "vue";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {CONTROLLER_EVENTNAMES} from "@k/global/GlobalEventnames";
import {useStore} from "vuex";
import {FontInformation} from "@k/js/fontHandler";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {setWatchToAnimateOnStatechange} from "@km/js/animater";
import type {TextObject} from "@k/js/selectableObjects";
import {useModuleTextOpenStatusStore} from "@km/store/frontendstate/useModuleTextOpenState";

const fontSelected = (selObId, font) => {
  EventVerteiler.broadcast(
      CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY,
      {
        id: selObId, changedProperties: {font: font}
      }
  );
}
const props = defineProps<{
  currentSelOb: TextObject | null
}>();



const store = useStore();
const openStatusStore=  useModuleTextOpenStatusStore();
const fonts = computed(() => store.getters["FontStore/getFlattenedFontGroups"]) as ComputedRef<FontInformation[]>
const getSVGName = url => 'https://static.owayo-cdn.com/' + url.replace('.woff', '.svg')
setWatchToAnimateOnStatechange(
    AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation('.km__modules__text--typeface'),
    new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {targetValue: 100, opacity: 0}),
    () => openStatusStore.getTypefaceState
);

</script>

<style lang="scss" scoped>

/* ***********************************
*	TEXT EDIT TYPEFACE
*	-
* -
* ********************************** */

/* ***********************************
*	TEXT LIST - Typeface Element
* ********************************** */
.km__typeface {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 75px;
  text-align: center;
  font-size: 16px;
  padding: 6px 10px;
}

/* ***********************************
*	TEXT LIST - Column 2 Typeface Elements
* ********************************** */
.km__modules__text--typeface {
  .km__list__element--modules {
    display: flex;
    flex-direction: column;

    &.active > span {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 2px solid $color-blue;
      }
    }
  }
}

/* ***********************************
*	TEXT EDIT TYPEFACE - Slider Typeface
* ********************************** */
.km__modules__text--typeface {
  position: fixed;
  height: 90px;
  width: 100%;
  right: -100%;
  bottom: calc(60px + #{$cta-height});
  z-index: 999;
  background: $color-white;
  padding: 10px 0 20px 10px;
  overflow-y: hidden;
  padding-bottom: 10px;
  opacity: 0;

  .km__list--modules {
    position: relative;
    padding-bottom: 170px;
    overflow-x: scroll;
    display: grid;
    grid-template-rows: repeat(2, auto);
    grid-gap: 10px 0;
    grid-auto-flow: column;
  }
}
</style>
